import { useState } from 'react';
import { selectChatFeedbacks, selectChatItems, selectIsLoading } from '../../store/appSlice';
import { useScrollToMessage } from './hooks';
import { useAppSelector } from '../../store/hooks';
import { ChatAnswerType } from '../../store/types';
import { Answer, AnswerError, AnswerLoading } from '../Answer';
import { UserChatMessage } from '../UserChatMessage';
import { ChatMessageStreamProps } from './types';

import styles from './ChatMessageStream.module.css';

export const ChatMessageStream = ({
  makeApiRequest,
  makeFeedbackRequest,
  questionInputRef,
}: ChatMessageStreamProps) => {
  const isLoading = useAppSelector(selectIsLoading);
  const chatItems = useAppSelector(selectChatItems);
  const chatFeedbacks = useAppSelector(selectChatFeedbacks);

  const [chatMessageRef, setChatMessageRef] = useState<HTMLDivElement | null>(null);
  useScrollToMessage(isLoading, chatItems, chatMessageRef, questionInputRef.current);

  return (
    <div className={styles.chatMessageStream}>
      {chatItems.map((chatItem) => (
        <div
          key={chatItem.id}
          className={styles.chatMessageItem}
          ref={
            chatItem.answer.type === ChatAnswerType.streaming ||
            chatItem.answer.type === ChatAnswerType.loading
              ? setChatMessageRef
              : null
          }
        >
          <UserChatMessage message={chatItem.question} />
          {chatItem.answer.type !== ChatAnswerType.error &&
            chatItem.answer.type !== ChatAnswerType.loading && (
              <div className={styles.chatMessageGpt}>
                <Answer
                  key={chatItem.id}
                  id={chatItem.id}
                  answer={chatItem.answer}
                  feedback={chatFeedbacks[chatItem.id]}
                  onFeedback={(payload) => makeFeedbackRequest(chatItem.id, payload)}
                />
              </div>
            )}
          {chatItem.answer.type === ChatAnswerType.loading && (
            <div className={styles.chatMessageGptMinWidth}>
              <AnswerLoading />
            </div>
          )}
          {chatItem.answer.type === ChatAnswerType.error && (
            <div className={styles.chatMessageGptMinWidth}>
              <AnswerError
                message={chatItem.answer.content}
                disabled={isLoading}
                showRetry={chatItem.answer.hasValidationErrors !== true}
                onRetry={() => makeApiRequest(chatItem.question, chatItem.id)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
